/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `5` - 5초
 * `10` - 10초
 */
export type SuggestedDurationEnum =
  (typeof SuggestedDurationEnum)[keyof typeof SuggestedDurationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuggestedDurationEnum = {
  NUMBER_5: "5",
  NUMBER_10: "10",
} as const;
